// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__1zi9e"};